import React from "react";
import { connect } from "react-redux";
import { store } from "../../redux/store";
import { resetMiscData, setCallBackUrl } from './../../redux/misc-data/misc-data.action';
import authReducer from './../../redux/auth/auth.reducer';
import ErrorImage from '../../assests/images/error.jpg'
import './errorPage.css';
import history from "../../auth/history";
import { Link } from "react-router-dom";
import { resetBillPayData } from "../../redux/billpayDetails/billpay.action";
import { resetRecharge } from "../../redux/recharge/recharge.action";
import { resetRetailerKyc } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";

class Logout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: ''
        }
    }

    componentDidMount() {
    }

    goToEmitra = () => {
        setTimeout(() => {
            store.dispatch(resetMiscData);
            store.dispatch(resetBillPayData);
            store.dispatch(resetRecharge);
            store.dispatch(resetRetailerKyc);
            localStorage.clear();
            window.location.href = this.props.callBackUrl;
        }, 1000);
    }


    componentWillUnmount() {
    }
    render() {


        return (

            <div class="eorpage">
                <div class="container">
                    <div class="row justify-content-md-center">
                        <div class="col-12 col-lg-6">
                            <div class="eortxt">
                                <img src={ErrorImage} alt="Error" class="img-fluid" />
                                <h3>{this.props.title}</h3>
                                <p>{this.props.description}</p>

                                {/* {this.props.callBackUrl != undefined &&
                                    this.props.callBackUrl != null &&
                                    this.props.callBackUrl != '' &&
                                    <button class="btn eorbtn" type="button" onClick={this.goToEmitra}>Go back to Emitra</button>

                                } */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = ({
    authReduce: { callBackUrl }
}
) => ({
    callBackUrl
});

export default connect(mapStateToProps, null)(Logout);
